import modals from "./modals";

class FreeAssessment {
    _searchTerms = [];
    _buttonClassList = [];
    _spanClassList = ["free-assessment"];
    _parentClassesToIgnore = [];

    get searchTerms() {
        return this._searchTerms;
    }

    set searchTerms(value) {
        this._searchTerms = value;
    }

    get buttonClassList() {
        return this._buttonClassList;
    }

    set buttonClassList(value) {
        this._buttonClassList = value;
    }

    addSearchTerm(searchTerm) {
        this._searchTerms.push(searchTerm);
    }

    addButtonClass(buttonClass) {
        this._buttonClassList.push(buttonClass);
    }

    get spanClassList() {
        return this._spanClassList;
    }

    set spanClassList(value) {
        this._spanClassList = value;
    }

    constructor(searchTerms = ["Free assessment", "Kostnadsfria Intresseanmälan", "Intresseanmälan", "Gratis Evaluering", "Gratis Vurdering"], buttonClassList = ["zoho-btn", "blank"], parentClassesToIgnore = ["footer-nav", "call-to-action", "header--home"]) {
        this._searchTerms = searchTerms;
        this._buttonClassList = buttonClassList;
        this._parentClassesToIgnore = parentClassesToIgnore;
        // console.log("search terms: ", this._searchTerms);
    }

    appendButton(span) {
        if (span.parentElement) {
            let button = document.createElement("button");
            button.classList.add(...this._buttonClassList);
            span.parentElement.insertBefore(button, span);
            button.appendChild(span);
        }
    }


    getAllParagraphs() {
        return document.querySelectorAll("p");
    }

    replaceTagWithSpan(node) {
        if (node.parentElement) {
            const span = document.createElement("span");
            span.classList.add(...this._spanClassList);
            span.innerHTML = node.innerHTML;
            node.parentElement.replaceChild(span, node);
            return span;
        }
    }

    convertNodeToSpan(node) {
        if (this.foundStringIsLink(node)) {
            // console.log("Node is a link");
            return this.replaceTagWithSpan(node)
        }

        if (this.foundStringIsButton(node)) {
            // console.log("Node is a button");
            if (!this.foundButtonContainsClasses(node, this._buttonClassList)) {
                return this.replaceTagWithSpan(node)
            }
        }

        return node;
    }

    wrapStringInSpan(nodeValue) {
        if (typeof nodeValue !== "string") {
            // if nodeValue is not a string then it must be a HTML element

            if(this.foundStringIsLink(nodeValue)) {
                this.convertNodeToSpan(nodeValue)
            }

            if (this.foundStringIsButton(nodeValue)) {
                if (this.foundButtonContainsClasses(nodeValue, this._buttonClassList)) {
                    return;
                }

                this.convertNodeToSpan(nodeValue);
            }
        }

        const classListString = this._spanClassList.join(" ");
        return `<span class="${classListString}">${nodeValue}</span>`;
    }

    nodeValueContainsSearchTerm(nodeValue, searchTerm) {
        return nodeValue.innerText.toLowerCase().includes(searchTerm.toLowerCase());
    }

    replaceAll(strReplace, strWith) {
        let esc = strReplace.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
        let reg = new RegExp(esc, 'ig');
        return this.replace(reg, strWith);
    }

    replaceStringWithSpan(nodeValue, searchTerm) {
        return this.replaceAll(nodeValue, searchTerm)
    }

    replaceWithSpan(node, searchTerm) {
        const text = node.nodeValue;
        const textParts = text.split(new RegExp(`(${searchTerm})`, 'gi'));
        // console.log("text parts: ", textParts);

        const fragment = document.createDocumentFragment();
        let spanList = [];

        textParts.forEach(part => {
            if (part.toLowerCase() === searchTerm.toLowerCase()) {
                const span = document.createElement('span');
                span.classList.add(...this._spanClassList);
                span.textContent = part;
                fragment.appendChild(span);
                spanList.push(span);
            } else {
                fragment.appendChild(document.createTextNode(part));
            }
        });

        if (node.parentNode) {
            node.parentNode.replaceChild(fragment, node);
        }

        return spanList;
    }

    ancestorHasClass(element, className) {
        // if element has an ancestor with the selected class
        if (element.classList.contains(className)) {
            return true;
        }

        if (element.closest(`.${className}`)) {
            return true;
        }

        return false;
    }

    ancestorHasClasses(element, classList) {
        let hasClass = false;
        classList.forEach((className) => {
            if (this.ancestorHasClass(element, className)) {
                // console.log("ancestor has class: ", className);
                hasClass = true;
            }
        });

        return hasClass;
    }

    /**
     * Searching for a term in a paragraph tag that are not wrapped in a button
     *
     * @param {string[]} searchTerms search term to find on page
     * @param {HTMLElement} paragraph paragraph to search in
     * @return {string[]} array of found strings
     */
    findUnwrappedTermsInParagraph(searchTerms, paragraph) {
        if (this.ancestorHasClasses(paragraph, this._parentClassesToIgnore)) {
            // console.log("paragraph has parent class to ignore");
            return [];
        }

        let walker = document.createTreeWalker(
            paragraph,
            NodeFilter.SHOW_ALL,
            null,
            false
        );

        let node;
        let textNodes = [];
        let foundTermsAsSpan = [];

        while(node = walker.nextNode()) {
            textNodes.push(node.nodeValue);
            // console.log("node: ", node);

            searchTerms.forEach((searchTerm) => {
                if (node.nodeValue && typeof node.nodeValue !== "string") {
                    if (this.nodeValueContainsSearchTerm(node, searchTerm)) {
                        if (this.foundStringIsLink(node)) {
                            // console.log("found string from link: ", node);
                            const span = this.convertNodeToSpan(node)
                            foundTermsAsSpan.push(span);
                            // console.log("new span from element: ", span);
                        }

                        if (this.foundStringIsButton(node)) {
                            if (this.foundButtonContainsClasses(node, this._buttonClassList)) {
                                // return;
                            } else {
                                // console.log("found string from button: ", node);
                                const span = this.convertNodeToSpan(node)
                                foundTermsAsSpan.push(span);
                                // console.log("new span from element: ", span);
                            }
                        }
                    }
                } else {
                    if (node.nodeValue && node.nodeValue.toLowerCase().includes(searchTerm.toLowerCase())) {
                        const spanList = this.replaceWithSpan(node, searchTerm);
                        foundTermsAsSpan.push(...spanList);
                        // console.log("found string (wrapped): ", node.nodeValue);
                        // node.nodeValue.replace(searchTerm, "<span>" + searchTerm + "</span>");
                    }
                }
            });
        }

        return foundTermsAsSpan;
    }

    /**
     * @param {HTMLElement} element element to check if it is a link
     * @return {boolean} true if element is a link
     */
    foundStringIsLink(element) {
        return element.tagName === "A";
    }

    foundStringIsButton(element) {
        return element.tagName === "BUTTON";
    }

    foundButtonContainsClass(button, className) {
        return button.classList.contains(className);
    }

    foundButtonContainsClasses(button, classList) {
        classList.forEach((className) => {
           if (!this.foundButtonContainsClass(button, className)) {
               return false;
           }
        });

        return true;
    }



    findAndReplace() {
        try {
            // getting all paragraphs on page
            let paragraphs = this.getAllParagraphs();
            const foundTermElements = [];

            // looping through all paragraphs
            Array.from(paragraphs).forEach((paragraph) => {
                // searching for search terms in paragraph
                foundTermElements.push(...this.findUnwrappedTermsInParagraph(this._searchTerms, paragraph));
            });

            foundTermElements.forEach((element) => {
                this.appendButton(element);
            });


            console.log("found term elements: ", foundTermElements);

        } catch (e) {
            console.error("error: ", e);
        }

        modals.init();
    }
}

export default FreeAssessment;
